import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'

import getters from './getters'
import mutations from './mutations'
import * as actions from './actions'
import moment from 'moment'
import { version } from '../../package.json'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    version: version,
    autoBCC: false,
    running: false,
    userEmail: null,
    userName: null,
    userAgentToken: null,
    artifacts: [],
    activity: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    activityDate: moment().dayOfYear(),
    devMode: false,
    devServer: '',
    bccEmails: [],
    bccWhenRecipientInEmails: [],
    dontBccWhenRecipientInEmails: [],
    subjectOptimize: true,
  },
  getters,
  mutations,
  actions,
  plugins: [vuexLocal.plugin]
})
